import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./css/surveysidebar.css";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import SitesService from "../../../../services/sites/sites.service";
import { getOnlyDateMMDDYY } from "../../../../utils/helpers";
import SurveyServices from "../../../../services/inspection-overview/site-operations/survey.services";
import {
  SurveyInfoReducer,
  ensureSurveyOverviewSummary,
} from "../../../../store/inspection-overview/site-operations/survey-details.store";
import { AppDispatch } from "../../../../store/store";
import { useDispatch } from "react-redux";
import { dataTablePaginatorTemplateSidebar } from "../../../common/dataTablePaginatorTemplates";

interface SurveyHistorySidebarProps {
  visible: boolean;
  onHide: () => void;
  onButtonClick: (value: string) => void;
  selectedHeaderInfo: any;
  surveyData: any[];
}

const SurveyHistorySidebar: React.FC<SurveyHistorySidebarProps> = (props: any) => {
  const { visible, onHide, surveyData }: any = props;
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState<[Date | undefined, Date | undefined]>([undefined, undefined]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [routeUrl, setRouteUrl] = useState("");
  const dispatch: AppDispatch = useDispatch();
  const [selectedButtons, setSelectedButtons] = useState<{[key: string]: boolean}>({});

  const handleClick = (buttonKey: string) => {
    setSelectedButtons((prevSelectedButtons) => ({
      ...prevSelectedButtons,
      [buttonKey]: !prevSelectedButtons[buttonKey],
    }));
  };

  useEffect(() => {
    setFilteredData(
      surveyData?.filter((data:any) =>
        data.cameraOperator?.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
  }, [searchValue, surveyData]);

  const handleDateClick = async (cameraSiteId: any="", surveyDate: any="",siteName:any ="") => {
    // SiteName will be always empty for Survey history
    setRouteUrl(`/regulatory-details`);
    SurveyServices.getSurveyInformation(
      cameraSiteId,
      surveyDate,
      siteName
    ).then((res: any) => {
      dispatch(SurveyInfoReducer(res as any));
    });
    dispatch(
      ensureSurveyOverviewSummary({
        cameraSiteId,
        surveyDate: getOnlyDateMMDDYY(surveyDate),
        siteName,
      })
    );
    onHide();
  };
  const handleCSVDownload = () => {
    const csvData = [
      [
        "Survey Date",
        "Leaks Detected",
        "Camera Operator",
        "Camera Type",
        "Survey Duration",
      ],
      ...surveyData?.map((item:any) => [
        item.surveyDate?getOnlyDateMMDDYY(item.surveyDate): "NA",
        (item.surveyDate !== "" && item.surveyDate != null)?(`${item.totalLeaks} ${"leaks detected"}`):"Not Surveyed",
        item.cameraOperator?item.cameraOperator:"NA",
        item.cameraType?item.cameraType:"NA",
        item.surveyDuration,
      ]),
    ];

    return csvData;
  };
  const csvFilename = `Survey_History_${Date.now()}`;
  const handleJsonDownLoad = async (cameraSiteId: any, surveyDate: any) => {
    try {
      const response = await SitesService.downloadJsonSites(cameraSiteId, surveyDate);
      const json = JSON.stringify(response);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Survey-History-${cameraSiteId}-${surveyDate}.json`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error('Error downloading JSON:', error);
    }
  };

  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={onHide}
      style={{ width: "60%", backgroundColor: "#272B34", color: "#FFFFFF" }}
      showCloseIcon={true}
    >
      <div>
        <header className="font-bold" style={{ fontSize: "18px" }}>{(surveyData && surveyData?.length <= 0)?`No Survey History for current Site`:`Select a survey`} </header>
        <hr />
        <div className="flex">
          <div>
            <div className="p-inputgroup flex-1 custom-inputgroup"></div>
          </div>
          <div className="ml-auto cursor-pointer">
            {/* <Dropdown
              value={dropdownValue}
              options={dropdownOptions}
              onChange={(e) => setDropdownValue(e.value)}
              placeholder="Select Operator : All"
              className="custom-dropdown"
              disabled
            /> */}
            &nbsp;
          </div>
          {/* <DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
            isClearable={true}
            className="date-picker"
            icon={<i className="pi pi-calendar" aria-hidden />}
            showIcon
            toggleCalendarOnIconClick
            placeholderText="Select date range"
          /> */}
          <div className="pl-2">
            {(surveyData && surveyData?.length <= 0)?(<Button
              className={`circular-button ${selectedButtons["download"] ? "selected" : "" }`}
              style={{backgroundColor: selectedButtons["download"] ? "#FFB217" : "", cursor:"not-allowed"}}
              data-tooltip-id="tooltip-download"
            >
              <i className="pi pi-download" />
            </Button>):(<Button
              className={`circular-button ${selectedButtons["download"] ? "selected" : "" }`}
              onClick={() => handleClick("download")}
              style={{backgroundColor: selectedButtons["download"] ? "#FFB217" : "", cursor:"pointer"}}
              data-tooltip-id="tooltip-download"
            >
              <CSVLink data={handleCSVDownload()} filename={csvFilename}>
                <i className="pi pi-download" />
              </CSVLink>
            </Button>)}
            
          </div>
        </div>
        {(surveyData && surveyData != null) && <DataTable
          value={surveyData}
          className="pt-4"
          paginator
          rows={11}
          paginatorTemplate={dataTablePaginatorTemplateSidebar}
        >
          <Column
            field="surveyDate"
            header="Survey Date"
            body={(rowData) => (
              <Button
                style={{
                  color: "#FFB217",
                  backgroundColor: "transparent",
                  border: "none",
                  padding: 0,
                  cursor:"pointer"
                }}
                onClick={() => handleDateClick(rowData.cameraSiteId, rowData.surveyDate,"")}
              >
                {rowData.surveyDate?getOnlyDateMMDDYY(rowData.surveyDate): "NA"}
              </Button>
            )}
          />
          <Column
            field="leaksDetected"
            header="Leaks Detected"
            body={(rowData) => (
              <div
                style={{
                  color: "#F97066",
                  border: "1px solid #F97066",
                  padding: "4px",
                  borderRadius: "4px",
                  width: "fit-content"

                }}
              >
                {`${rowData.totalLeaks} ${"leaks detected"}`}
              </div>
            )}
          />
          <Column 
            field="cameraOperator" 
            header="Camera Operator"
            body={(rowData) => <span>{rowData.cameraOperator?rowData.cameraOperator:"NA"}</span>} 
          />
          <Column 
            field="cameraType" 
            header="Camera Type"
            body={(rowData) => <span>{rowData.cameraType?rowData.cameraType:"NA"}</span>} 
          />
          <Column field="surveyDuration" header="Survey Duration"
            body={(rowData) => <span>{rowData.surveyDuration?rowData.surveyDuration:"NA"}</span>}  />
          <Column
            body={(rowData) => (
              <div>
                <Button
                  icon="pi pi-download"
                  style={{
                    background: "none",
                    border: "none",
                    color: "#FFFFFF",
                    paddingLeft: "50px",
                  }}
                  onClick={() => handleJsonDownLoad(rowData.cameraSiteId, rowData.surveyDate)}
                />
              </div>
            )}
          />
        </DataTable>}
        <hr />
      </div>
    </Sidebar>
  );
};

export default SurveyHistorySidebar;
